import { apiRequest } from './client';
import type {
  ChangePasswordInput,
  ForgotPasswordInput,
  LoginInput,
  LoginResponse,
  RegisterInput,
  RegisterResponse,
  ResetPasswordInput,
  Session,
} from '@/types';

export const authApi = {
  login(input: LoginInput): Promise<LoginResponse> {
    return apiRequest('/api/v1/auth/login', { method: 'POST', body: input });
  },

  register(input: RegisterInput): Promise<RegisterResponse> {
    return apiRequest('/api/v1/auth/register', { method: 'POST', body: input });
  },

  logout(): Promise<void> {
    return apiRequest('/api/v1/auth/logout', { method: 'POST' });
  },

  getSession(): Promise<Session> {
    return apiRequest('/api/v1/auth/session');
  },

  changePassword(input: ChangePasswordInput): Promise<{ ok: boolean }> {
    return apiRequest('/api/v1/auth/change-password', { method: 'POST', body: input });
  },

  forgotPassword(input: ForgotPasswordInput): Promise<{ ok: boolean; message?: string }> {
    return apiRequest('/api/v1/auth/forgot-password', { method: 'POST', body: input });
  },

  resetPassword(input: ResetPasswordInput): Promise<{ ok: boolean }> {
    return apiRequest('/api/v1/auth/reset-password', { method: 'POST', body: input });
  },
};
